import { ReactNode } from 'react';

export const Step = ({
    index,
    title,
    description,
    image,
}: {
    index: number;
    title: string;
    description: string | ReactNode;
    image: string;
}) => {
    return (
        <div className="flex h-[60px] items-center gap-[12px] max-lg:h-[70px]">
            <div className="relative flex h-[50px] w-[50px] shrink-0 items-center justify-center rounded-[10px] bg-[radial-gradient(125%_125%_at_50%_50%,#ffffff_0%,#94d3ff_100%)]">
                <div className="absolute left-0 top-0 flex h-[17px] w-[17px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-[50%] bg-primary text-[9px] font-bold text-white">
                    {index}
                </div>
                <img src={image} alt="step icon" />
            </div>
            <div>
                <div className="font-semibold">{title}</div>
                <div className="text-[#949494]">{description}</div>
            </div>
        </div>
    );
};
